<template>
  <div class="order-details-commerce-agent-delivery">
    <p class="header">
      <span @click="close">
        <i class="fa fa-chevron-left" style="padding-right: 12px" />
        <span class="state">{{ descriptiveDeliveryState }}</span>
      </span>
      <span
        v-if="isSuperUser()"
        class="button is-small is-rounded is-pulled-right is-dark"
        @click="remindDriver"
      >
        <i class="fa fa-bullhorn" />
      </span>
    </p>

    <div class="card">
      <div class="card-content">
        <div style="display: flex; padding: 12px">
          <div class="left has-text-centered">
            <p><i class="fa fa-store-alt has-text-grey" /></p>
            <p>
              <i class="fa fa-ellipsis-v fa-sm" style="color: grey" />
            </p>
            <p><i class="fa fa-map-marker-alt has-text-success" /></p>
          </div>
          <div class="right has-text-left">
            <p class="clamp" style="height: 48px">
              {{ $t("Order from ") }}
              <a :href="googleMapPickup" target="_blank" class="has-text-link">
                {{ pickupName }}
              </a>
            </p>
            <p v-if="t.data.dropoff_stop" class="single-line">
              {{ $t("Delivering to") }}
              <a :href="googleMapDropoff" target="_blank" class="has-text-link">
                {{ dropoffName }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="card delivery-info">
      <p
        style="height: 50px; margin-bottom: 4px; overflow: hidden"
        @click="copy(notes)"
      >
        <i class="far fa-comment-alt" style="margin-right: 6px" />
        Address notes:<span class="has-text-link"> {{ notes }} </span>
        <i v-if="notes" class="far fa-copy fa-sm has-text-black" />
      </p>
      <!-- <p style="margin-bottom: 6px" @click="openGoogleMaps">
        <i class="fa fa-directions" style="margin-right: 6px" />
        <span class="link">Open in Google Maps</span>
        <i class="fa fa-external-link-alt has-text-grey is-pulled-right" />
      </p> -->
      <p>
        <span @click="copyText(latLon)">
          <i class="fa fa-copy" style="margin-right: 9px" />
          <span style="color: grey; margin-right: 6px; font-size: 0.9em">{{
            latLon
          }}</span>
          <span class="link hint">Copy</span>
        </span>
        <i
          class="fa fa-external-link-alt has-text-grey is-pulled-right"
          @click="openGoogleMaps"
        />
      </p>
    </div>

    <!-- <div class="update-btn tag pulse" @click="update">
      <i class="fa fa-redo-alt fa-sm" />&nbsp;
      <span @click="pingDriver">Update Driver Location</span>
    </div> -->

    <div v-if="!isOngoing" class="update-btn tag is-success">
      <i class="fa fa-check-circle" style="margin-right: 6px" />Delivery
      completed {{ updatedMinutesAgo }} mins ago
    </div>

    <CommerceOrderDeliveryMap
      :delivery="t"
      :hideDriver="hideDriver"
      :notes="notes"
    />
  </div>
</template>

<script>
import CommerceOrderDeliveryMap from "@/components/CommerceOrderDeliveryMap";
// import RideBookingDriver from "@/components/RideBookingDriver";

export default {
  name: "OrderDetailsCommerceAgentDelivery", //"CommerceOrderDeliveryWall",
  components: {
    CommerceOrderDeliveryMap,
    // RideBookingDriver
  },
  props: {
    t: Object,
    notes: String,
  },
  data() {
    return {
      placeholderPic: this.$store.state.menuItemPlaceholderPic,
    };
  },
  computed: {
    latLon() {
      var lat = this.t.data.dropoff_stop.lat.toFixed(6);
      var lon = this.t.data.dropoff_stop.lon.toFixed(6);
      return `${lat},${lon}`;
    },
    dropoffDirectionsURL() {
      if (!this.t.data.dropoff_stop) return;
      // var url = "https://www.google.com/maps?saddr=My+Location&daddr=";
      var current = this.$store.state.userState;
      var scoords = `${current.lat},${current.lon}`;
      var dcoords = `${this.t.data.dropoff_stop.lat},${this.t.data.dropoff_stop.lon}`;
      return `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`;
    },
    updatedMinutesAgo() {
      var updatedAt = new Date(this.t.updated_at);
      return Math.round((new Date() - updatedAt) / (1000 * 60));
    },
    hideDriver() {
      if (this.isSuperUser()) return false; // always show for super user
      return this.updatedMinutesAgo > 60;
      // if (this.t.state === "enroute") return true;
      // if (this.t.state === "alighted") {
      //   if (this.updatedMinutesAgo < 60) return true;
      // }
      // return false;
    },
    isOngoing() {
      if (this.t.state === "alighted") return false; // alighted is still on_going for 24 hours
      return this.t.is_ongoing;
    },
    driverPic() {
      return this.t.driver.profile_pic_url || this.placeholderPic;
    },
    shopContactable() {
      return true; // should be false if order is completed / cancelled and older than x hours
    },
    driverContactable() {
      if (!this.t) return false; // may not have driver yet
      var states = [
        "initiated",
        "confirmed",
        "driver_arrived",
        "cancelled_by_driver",
      ];
      if (states.includes(this.t.state)) return false;
      // also return false if cancelled alighted/no_show and older than x hours
      return true;
    },
    pickupName() {
      return this.t.data.pickup_stop.name || this.$t("ride.pin-location");
      //   return this.shortenString(this.t.data.pickup_stop.name, 40);
    },
    dropoffName() {
      return this.t.data.dropoff_stop.name || this.$t("ride.pin-location");
      //   return this.shortenString(this.t.data.dropoff_stop.name, 40);
    },
    googleMapPickup() {
      var a = this.t.data.pickup_stop;
      return `http://www.google.com/maps/place/${a.lat},${a.lon}`;
    },
    googleMapDropoff() {
      var a = this.t.data.dropoff_stop;
      return `http://www.google.com/maps/place/${a.lat},${a.lon}`;
    },
    descriptiveDeliveryState() {
      if (!this.t) return "Delivery Details";
      switch (this.t.state) {
        case "initiated":
          return "Requesting delivery driver";
        case "confirmed":
          return "Driver heading to pickup";
        case "driver_arrived":
          return "Driver arrived at pickup";
        case "enroute":
          return "Driver enroute to dropoff";
        case "alighted":
          return "Delivery dropped off";
        default:
          return "Delivery Details";
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    copy(txt) {
      this.$copyText(txt);
      this.infoToast("Copied to clipboard!<br>" + txt);
    },
    remindDriver() {
      var driverID = this.t.driver.id;
      // var txt = "📌 Remember to click the buttons and update your GPS 🧭";
      var txt = "📌 อย่าลืมคลิกปุ่มและอัปเดต GPS ของคุณ 🧭";
      this.sendPushNotification(txt, driverID);
      this.warningToast("Driver has been reminded!", "top");
    },
    openGoogleMaps() {
      window.open(this.googleMapDropoff, "_target");
    },
    update() {
      this.$emit("update");
    },
    driverStale() {
      if (!this.t.driver) return false;
      return this.secondsAgo(this.t.driver.user_state.updated_at) < 60;
    },
    pingDriver() {
      if (!this.driverStale()) return; // don't ping if driver position is not stale
      var msg = `We've asked the driver 🏍<br>to update their GPS location 📍<br>Please check back in a minute 🙏🏼`;
      this.infoToast(msg, "bottom", 10000);
      this.$store
        .dispatch("sendMessageToUser", {
          user_id: this.t.driver.id,
          message: "📍PLEASE UPDATE YOUR GPS LOCATION🧭🙏🏼",
          type: "push", // send type: sms or push
        })
        .catch((err) => console.log("pingDriver to update their GPS", err)); //this.apiError(err));
    },
    showTimeAgo() {
      var msg = `Updated ${this.updatedMinutesAgo} mins ago`;
      this.infoToast(msg, "top");
    },
    triggerHelp() {
      this.$emit("triggerHelp");
      this.close();
    },
    callShop() {
      this.$emit("callShop");
    },
    copyText(str) {
      this.$copyText(str);
      this.infoToast("Copied to clipboard", "top");
    },
    // copyOrderURL() {
    //   this.$copyText(window.location.href);
    //   this.infoToast("Info copied to clipboard");
    // },
    // gotoChatSupport() {
    //   this.copyOrderURL();
    //   this.infoToast("Opening chat now...");
    //   setTimeout(() => {
    //     window.open("https://m.me/tukapp", "_blank");
    //   }, 1000);
    // },
    // callShop() {
    //   this.callPhoneNumber(this.t.business.data.phone_number);
    // },
    // callDriver() {
    //   this.callPhoneNumber(this.t.driver.phone_number);
    // },
  },
};
</script>

<style scoped>
/* .commerce-order-delivery-wall { */
.order-details-commerce-agent-delivery {
  height: 100vh;
  width: 100vw;
  max-width: 600px;
  overflow: hidden;
  text-align: left;
  background-color: white;
  z-index: 3;
  padding: 0;
  margin: auto;
  outline: 1px solid #ccc;
}
.top {
  border: 1px dotted grey;
  flex: 0 1 auto;
  /* Shorthand for flex-grow: 0, flex-shrink: 1, flex-basis: auto */
}
.bottom {
  border: 1px dotted green;
  flex: 1 1 auto;
}
.header {
  /* position: relative; */
  padding: 12px;
  padding-left: 12px;
  /* padding-bottom: 4px; */
  /* margin-bottom: 10px;
  margin-top: 10px; */
  font-size: 1.1em;
  z-index: 4;
  background-color: #ddd;
}
.header .state {
  font-weight: 500;
}
.card-content {
  padding: 0;
  margin: 0;
}
.card-content .fa {
  margin-right: 10px;
}
.column {
  padding: 0;
  margin: 0;
}
.driver-pic {
  object-fit: cover;
  border-radius: 5px;
  height: 80px;
  width: 80px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}
/* .hint {
  font-weight: 500;
  font-size: 0.8em;
} */
/* a {
  white-space: nowrap;
  text-overflow: ellipsis;
} */
.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* padding-right: 4px; */
}
.single-line {
  width: calc(100vw - 44px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.update-btn {
  position: absolute;
  /* left: 0px; */
  top: 248px;
  z-index: 3;
  margin: 10px;
  /* padding: 8px; */
  border-radius: 25px;
  box-shadow: 1px 1px 3px grey;
  background-color: white;

  /* color: grey; */
  color: blue;
  border: 1px solid blue;
  /* font-size: 0.8em; */
  /* line-height: 1em; */
}
.update-btn.is-success {
  border: initial;
  font-weight: 500;
  font-size: 0.85em;
}
/* .problem-btn {
  position: absolute;
  left: 0px;
  bottom: 0px;
  z-index: 3;
  margin: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 25px;
  box-shadow: 1px 1px 3px grey;
  color: grey;
  font-weight: 500;
} */
.problem-btn {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
  padding: 16px 6px;
  /* background-color: rgba(255, 255, 255, 0.7); */
  /* border-radius: 25px; */
  /* box-shadow: 1px 1px 3px grey; */
  color: grey;
  font-weight: 500;
  font-size: 0.75em;
  /* max-width: 60px; */
}
.delivery-info {
  padding: 8px 12px;
  height: 102px;
  overflow: scroll;
}
.delivery-info .fa,
.delivery-info .far {
  color: grey;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px yellow inset;
  }
  100% {
    box-shadow: 0 0 0 15px yellow inset;
  }
}
.pulse {
  animation: shadow-pulse-gold 1s infinite ease-out;
}
.hint {
  color: grey;
  font-size: 0.8em;
  font-weight: 500;
  opacity: 0.7;
}
</style>